export default __webpack_public_path__ + "static/media/add.26823c81.jpg";